// TODO: Move to a const, it's not an enum if it has only one element
export var TriggerTypeEnum;
(function (TriggerTypeEnum) {
    TriggerTypeEnum["EVENT"] = "event";
})(TriggerTypeEnum || (TriggerTypeEnum = {}));
//# sourceMappingURL=notification-trigger.interface.js.map